import { render, staticRenderFns } from "./admin-two-factor-auth.vue?vue&type=template&id=3f3d8db4"
import script from "./admin-two-factor-auth.vue?vue&type=script&lang=js"
export * from "./admin-two-factor-auth.vue?vue&type=script&lang=js"
import style0 from "./admin-two-factor-auth.vue?vue&type=style&index=0&id=3f3d8db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports